import { useFilter } from "../../../fetch/fetch.filter.ts";
import { EMPTY_FILTER } from "../../../const/typeDefault/Filter.ts";
import { parseError } from "../../../types/Error/Errors.ts";

const FilterTitle = ({ id }: { id: string }) => {
  const { filter, isLoading, isError } = useFilter(id, EMPTY_FILTER);
  if (isLoading) return "Loading...";
  if (isError) return parseError(isError);
  return filter.title;
};
export default FilterTitle;
